import { render, staticRenderFns } from "./OrganizationTagEditDialog.vue?vue&type=template&id=69872a1e&scoped=true"
import script from "./OrganizationTagEditDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationTagEditDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTagEditDialog.vue?vue&type=style&index=0&id=69872a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69872a1e",
  null
  
)

export default component.exports